/*
 * @Author: bill
 * @Date: 2024-05-21 08:55:42
 * @LastEditors: wangzijun@bzstech.com wangzijun@bzstech.com
 * @LastEditTime: 2024-06-11 09:43:15
 * @FilePath: /study/src/routes/routes.tsx
 * @Description:
 */
import React from "react";

const HomePage = React.lazy(() => import("../pages/home/Home"));
const Classification = React.lazy(
  () => import("../pages/classification/Classification")
);
const Course = React.lazy(() => import("../pages/course/Course"));
const Courseware = React.lazy(() => import("../pages/courseware/Courseware"));
const Evaluation = React.lazy(() => import("../pages/evaluate/Evaluate"));

export interface IRoute {
  caseSensitive?: boolean;
  children?: Array<IRoute>;
  element?: React.ReactNode | null;
  index?: false;
  path: string;
  key?: any;
  title?: string;
  [name: string]: any;
}

export const routes: Array<IRoute> = [
  {
    path: "/",
    element: <HomePage />,
    title: "首页",
  },
  {
    path: "/classify",
    element: <Classification />,
    title: "分类",
  },
  {
    path: "/course",
    element: <Course />,
    title: "课程管理",
  },
  {
    path: "/courseware/:id/:type",
    element: <Courseware />,
    title: "课件管理",
  },
  {
    path: "/evaluate",
    element: <Evaluation />,
    title: "评论管理",
  },
];
